import { Component, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-date-config',
  templateUrl: './d-date-config.component.html',
  styles: []
})
export class DDateConfigComponent extends DynamicComponentBase {
  static KEY = 'd-date-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {}
}
